/**
 * 日志上报队列管理器
 * 使用父类包进行上报
 */

export enum ReportPriority {
  IMMEDIATE = 'immediate', // 立即上报
  DEFERRED = 'deferred',   // 延迟上报
}

export interface MetricData {
  metric_name: string;
  tags: Record<string, any>;
  value: number;
  message: string;
  params?: any;
}

export class MetricReporter {
  private parentReporter: { smartReport: Function, reportImmediate: Function, reportDeferred: Function } = {
    smartReport: () => { },
    reportImmediate: () => { },
    reportDeferred: () => { }
  };

  constructor() {

  }

  /**
   * 设置实际的上报函数
   */
  public setMetricFunction(reporter: typeof this.parentReporter) {
    this.parentReporter = reporter;
  }

  /**
   * 上报日志 - 根据优先级选择策略
   */
  public report(data: MetricData, priority: ReportPriority = ReportPriority.DEFERRED) {
    if (priority === ReportPriority.IMMEDIATE) {
      this.reportImmediate(data);
    } else {
      this.reportDeferred(data);
    }
  }

  /**
   * 立即上报(高优先级)
   * 用于：错误日志、关键失败、超时等
   */
  private reportImmediate(data: MetricData) {
    this.parentReporter.reportImmediate(data);
  }

  /**
   * 延迟上报(低优先级)
   * 用于：成功日志、性能指标、统计数据等
   */
  private reportDeferred(data: MetricData) {
    this.parentReporter.reportDeferred(data);
  }
}

// 创建单例实例
const metricReporter = new MetricReporter();

export default metricReporter;
